import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { H2 } from 'components/common/Text/Text'

export const Heading = styled(H2)`
  ${Mixin.font.GothamBold(26)}
  vertical-align: 2px;
  text-transform: uppercase;
  text-align: center;
  ${Mixin.responsive('font-size', '26px', '20px')}
  ${Mixin.responsive('padding', '50px 0 30px', '10px 0 5px')}
  transform: scale(1, 1.3);
`
